export default {
    ufVoicePolicy: '/voice-policies/input/voicePolicy',
    ufPattern: '/voice-policies/input/pattern',
};
